const ENVConfig = {
  // baseURL: "http://3.7.77.174:8105/api",
  //baseURL: "http://13.235.37.117:8265/api/v1/", // for int dev
  // baseURL: "http://localhost:8080/api/v1/", // /for local
  baseURL: "/api/v1/", // for acg
};
export default ENVConfig;
